// extracted by mini-css-extract-plugin
export default {"technologyCardContainer":"technology_technologyCardContainer__DZfrV"};